export const esAlumno = (usuario) => Boolean(usuario)
  && !usuario.teacher && !usuario.isMaster && usuario.isSuperAdmin !== true;

export const esAlumnoOculto = (usuario) => esAlumno(usuario)
  && (usuario.ocultoEnListados === true || usuario.usuarioPrueba === true);

// Usar este criterio también al agregar futuras métricas de actividad/presencia.
export const cuentaEnMetricas = (usuario) => Boolean(usuario)
  && usuario.isSuperAdmin !== true && !esAlumnoOculto(usuario);
